import { useEffect, useRef } from "react";
import { useAuth } from "../hooks/useAuth";
import { subscribePendingArenaInvitationsForUser } from "../services/arenaInvitationService";
import { publishArenaInvitationNotification } from "../services/arenaInvitationService";

/**
 * Backfill pending arena invitations into durable inbox (deduped by invitation id).
 */
export default function ArenaInvitationNotificationSync() {
  const { uid, isAuthenticated } = useAuth();
  const seenRef = useRef(new Set());

  useEffect(() => {
    if (!isAuthenticated || !uid) return undefined;

    return subscribePendingArenaInvitationsForUser(uid, (list) => {
      (list || []).forEach((inv) => {
        const id = inv?.invitationId;
        if (!id || seenRef.current.has(id)) return;
        seenRef.current.add(id);
        void publishArenaInvitationNotification(inv, uid);
      });
    });
  }, [isAuthenticated, uid]);

  return null;
}
